import { render } from "./EventSmall.vue?vue&type=template&id=76f3f02f&scoped=true"
import script from "./EventSmall.vue?vue&type=script&lang=js"
export * from "./EventSmall.vue?vue&type=script&lang=js"

import "./EventSmall.vue?vue&type=style&index=0&id=76f3f02f&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f3f02f"]])

export default __exports__